import QRCode from 'qrcode';
export async function renderSvgQr(container, text, hasGetSVG = false) {
  const svg = await QRCode.toString(text, {
    type: "svg",
    width: 200,
    color: { dark: "#000000", light: "#ffffff" },
    errorCorrectionLevel: "H",
  });
  if (hasGetSVG) {
    return svg;
  } else {
    container.innerHTML = svg; // injeta o SVG no DOM
    return;
  }
}

export async function renderSvgQr2(slug){
  const svg = await QRCode.toString(slug, {
    type: "svg",
    width: 200,
    color: { dark: "#000000", light: "#ffffff" },
    errorCorrectionLevel: "H",
  });
  return svg;
};

// garante uso no escopo global do browser
if (typeof window !== 'undefined') {
  window.renderSvgQr = renderSvgQr;
  window.renderSvgQr2 = renderSvgQr2;
}
